const prefix = "typesetting";
const safeSpacingValue = /^[a-zA-Z0-9 .%()+*,/_-]+$/;
const normalizeSpacingValue = (value) => {
  if (typeof value !== "string") return "0.2em";
  const trimmed = value.trim();
  return trimmed && safeSpacingValue.test(trimmed) && !trimmed.includes("/*") && !trimmed.includes("*/") ? trimmed : "0.2em";
};
const escapeAttribute = (value) => value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const createWbr = () => {
  return "<wbr>";
};
const createThinSpace = (thinSpaceWidth, breakable) => {
  const content = "";
  const className = `${prefix}-thin-space`;
  return createSpacer(content, className, normalizeSpacingValue(thinSpaceWidth), breakable);
};
const createKerning = (kerningValue, breakable) => {
  if (kerningValue === 0) return "";
  const content = "";
  const className = `${prefix}-kerning`;
  if (kerningValue < 0) {
    const emValue = kerningValue / 1e3 / 2 + "em";
    const style = `margin: ${emValue};`;
    return createStyledSpan(content, className, style);
  } else {
    const emValue = kerningValue / 1e3 + "em";
    return createSpacer(content, className, emValue, breakable);
  }
};
const applyWrapperStyle = (text, useWordBreak) => {
  const wrapperName = `${prefix}-wrapper`;
  const wordBreakName = `${prefix}-word-break`;
  const className = useWordBreak ? `${wrapperName} ${wordBreakName}` : wrapperName;
  return createStyledSpan(text, className);
};
const applyLatinStyle = (segment) => {
  const className = `${prefix}-latin`;
  return createStyledSpan(segment, className);
};
const applyNoBreaksStyle = (segment) => {
  const className = `${prefix}-no-breaks`;
  return createStyledSpan(segment, className);
};
const createStyledSpan = (content, className, style = "", attr = "") => {
  const styleAttr = style ? ` style="${escapeAttribute(style)}"` : "";
  return `<span class="${className}"${styleAttr}${attr}>${content}</span>`;
};
const createSpacer = (content, className, value, breakable) => {
  const style = `letter-spacing: ${value};`;
  const data = ` data-content="${breakable ? " " : "&nbsp;"}"`;
  return createStyledSpan(content, className, style, data);
};
export {
  applyLatinStyle,
  applyNoBreaksStyle,
  applyWrapperStyle,
  createKerning,
  createThinSpace,
  createWbr,
  normalizeSpacingValue
};
